function createEl(tag, props, parent) {
  let el = document.createElement(tag)
  for (const [key, value] of Object.entries(props) ) {
    if(key === "innerText") {
      el.innerText = value
      continue
    }
    el.setAttribute(key, value)
  }
  if(parent) {
    if(typeof parent === "string") {
      parent = document.querySelector(parent)
    }
    parent.appendChild(el)
  }
  return el
}

export {createEl}
